import React from 'react';
import { MenuItem, SelectChangeEvent,FormHelperText } from '@mui/material';
import { SelectOptionProps } from '../../helpers/types';
import {
  SelectWrapper,
  StyledFormControl,
  StyledSelect,
  StyledInputLabel
} from './SelectOption.styles';

const SelectOption = ({
  label,
  value,
  defaultValue,
  onChange: providedOnChange,
  options,
  width,
  error,
  helperText,
  placeholder,
}: SelectOptionProps) => {
  return (
    <SelectWrapper sx={{ width }}>
      <StyledFormControl size="small" error={error} fullWidth>
        <StyledInputLabel>{label}</StyledInputLabel>
        <StyledSelect
          value={value}
          label={label}
          onChange={(event) => {
            if (providedOnChange) {
              providedOnChange(event as SelectChangeEvent<string>, null);
            }
          }}
          displayEmpty
          defaultValue={defaultValue}
        >
          <MenuItem disabled value="">
            <em>{placeholder}</em>
          </MenuItem>
          {options?.map((item: any) => (
            <MenuItem
              sx={{
                textTransform: 'capitalize',
                ...(item.disabled && {
                  color: 'text.disabled',
                  backgroundColor: 'action.disabledBackground'
                })
              }}
              key={item.value}
              value={item.value}
              disabled={item.disabled}>
              {item.label}
            </MenuItem>
          ))}
        </StyledSelect>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </StyledFormControl>
    </SelectWrapper>
  );
};

export default SelectOption;
